// Severity color mapping configuration
export const SEVERITY_COLORS = {
  Extreme: "error",
  Severe: "error",
  Moderate: "warning",
  Minor: "success",
  Info: "info",
  High: "error",
  Low: "success",
  Critical: "error",
  Medium: "warning",
  Unknown: "secondary",
};

// Helper function to get severity color
export const getSeverityColor = (severity) => {
  return SEVERITY_COLORS[severity] || "secondary";
};
